import {
  Component,
  Input,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { PatientService } from "../../../services/patient.service";
import * as moment from "moment";
import { AdjudicationService } from "../../../services/adjudication.service";
import {
  Adjudication,
  MactelDiagnosis,
} from "../../../models/adjudication.model";
import { Patient } from "../../../models/patient.model";
import { AdjudicateComponent } from "../../grading/adjudication/adjudication-modal.component";
import { UserPermissions, AuthService } from "../../../services/auth.service";
import { ImagePackageService } from "../../../services/image-package.service";

@Component({
  template: `
    <div class="tab-body row no-margin details">
      <div class="col-6">
        <div class="row details-header-row">
          <p class="subheading">MacTel Diagnosis</p>
          <i
            *ngIf="userPermissions?.mactelDiagnosis"
            class="material-icons"
            (click)="editDiagnosis()"
            >edit</i
          >
        </div>
        <ul>
          <li class="row">
            <div class="col-3"><label>Patient ID</label></div>
            <div class="col-9">{{ adjudication?.patientId }}</div>
          </li>
          <li class="row">
            <div class="col-3"><label>MacTel Diagnosis</label></div>
            <div class="col-9">
              {{
                mactelDiagnoses &&
                  adjudication?.mactelDiagnosis &&
                  mactelDiagnoses[adjudication?.mactelDiagnosis.toLowerCase()]
                  | titlecase
              }}
            </div>
          </li>
          <li class="row">
            <div class="col-3"><label>Sub Study</label></div>
            <div class="col-9">{{ adjudication?.subStudy | titlecase }}</div>
          </li>
          <!-- <li class="row">
            <div class="col-3"><label>Grading Eligible</label></div>
            <div class="col-9">{{adjudication?.gradingEligible}}</div>
          </li> -->
          <li class="row">
            <div class="col-3">
              <label>Presence of MacTel BLR Pattern</label>
            </div>
            <div class="col-9">{{ adjudication?.blrPattern }}</div>
          </li>
          <li class="row">
            <div class="col-3"><label>BLR Eye</label></div>
            <div class="col-9">{{ adjudication?.blrEye }}</div>
          </li>
        </ul>
      </div>

      <div class="col-6">
        <p class="subheading">Notes</p>
        <div class="notes">
          <li *ngFor="let note of adjudication?.notes">
            {{ note.createdAt | date : "mediumDate" }} - {{ note.user?.name }} -
            {{ note.body }}
          </li>
        </div>
      </div>
    </div>

    <lowy-adjudicate
      #lowyAdjudicate
      (saved)="adjudicationSaved()"
    ></lowy-adjudicate>
  `,
  styleUrls: ["../data-details.component.scss"],
  selector: "lowy-mactel-diagnosis-tab",
  providers: [
    PatientService,
    AdjudicationService,
    AuthService,
    ImagePackageService,
  ],
})
export class MactelDiagnosisTabComponent implements OnInit {
  @Input("patient")
  set patient(patient: Patient) {
    if (patient) {
      this._patient = patient;
      this.notes = patient["notes"];
      this.adjudicationService
        .getAdjudication(patient.patientId)
        .then((adjudication) => {
          this.adjudication = adjudication;
        });
    }
  }
  private _patient: Patient;

  public adjudication: Adjudication;
  public notes: string;
  public mactelDiagnoses;
  public userPermissions: UserPermissions;

  @Output() updated: EventEmitter<null>;

  @ViewChild("lowyAdjudicate") lowyAdjudicate: AdjudicateComponent;

  public moment = moment;

  constructor(
    private router: Router,
    private patientService: PatientService,
    private adjudicationService: AdjudicationService,
    private authService: AuthService,
    private imagePackageService: ImagePackageService
  ) {
    this.updated = new EventEmitter();
    this.mactelDiagnoses = MactelDiagnosis;
  }

  async ngOnInit() {
    this.authService.permissions$.subscribe((permissions) => {
      this.userPermissions = permissions;
    });
  }

  async editDiagnosis() {
    const imagePackage = await this.imagePackageService.getImagePackage(
      this._patient.patientId
    );
    this.lowyAdjudicate.open(imagePackage);
  }

  adjudicationSaved() {
    this.updated.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/data/tabs/mactel-diagnosis-tab.component.ts